import React from 'react';
import './details-item-text.scss';
import { DetailsItem } from '../details-item';
import { CopyButton } from '../../../copy-button/copy-button';

interface IProps {
    title: string | JSX.Element;
    value: string;
    className?: string;
    copyButton?: boolean;
}

const DetailsItemText = (props: IProps) => {
    return (
        <DetailsItem title={props.title}>
            <p className={props.className}>{props.value}</p>
            {props.copyButton &&
                <div className='buttons-block'>
                    <CopyButton copyValue={props.value} />
                </div>
            }
        </DetailsItem>
    );
};

export { DetailsItemText };